import { BaseState } from "~/store/store.types"
import { getRelationships } from "./getRelationships"

/**
 * Get a single resource from the Vuex Store
 *
 * @export
 * @template T
 * @param {BaseState<T>} state
 * @param {string} id
 * @param {string|string[]} [includeRelationships=[]]
 * @param {*} rootGetters
 * @returns {T['attributes']}
 */
export function getResource<T extends JsonApi.ResourceObject>(
  state: BaseState<T>,
  id: string,
  rootGetters: any = {},
  includeRelationships: string | string[] = [],
  getterOverrides: { [type: string]: string } = {}
): T['attributes'] {
  const resource = state.data[id]

  if (!resource) {
    if (process.env.NODE_ENV !== 'test') {
      console.error(`Resource "${id}" does not exist`)
    }
    return {}
  }

  const { attributes, relationships } = resource

  return { id, ...attributes, ...getRelationships(relationships, rootGetters, includeRelationships, getterOverrides) }
}
